import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const UpcomingEvents = ({ events = [] }) => {
    const navigate = useNavigate();
    const formatTime = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        if (date.toDateString() === today.toDateString()) return 'Today';
        if (date.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    };

    return (
        <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm">
            <h3 className="text-[11px] font-normal text-slate-900 mb-4">Upcoming Events</h3>
            
            <div className="space-y-3">
                {events.length > 0 ? events.slice(0, 3).map((event, idx) => (
                    <div key={idx} className="flex items-center gap-3 p-2.5 rounded-xl border border-slate-50 bg-slate-50/50 hover:bg-slate-100 transition-all group cursor-pointer">
                        <div className="w-9 h-9 rounded-xl bg-white border border-slate-200 flex flex-col items-center justify-center shrink-0 shadow-sm group-hover:border-emerald-400 group-hover:shadow-emerald-100 transition-all">
                            <span className="text-[10px] font-normal text-emerald-600 leading-none">
                                {new Date(event.scheduled_at?.Time || event.scheduled_at).getDate()}
                            </span>
                            <span className="text-[7px] font-normal text-slate-700 tracking-tighter">
                                {new Date(event.scheduled_at?.Time || event.scheduled_at).toLocaleString('default', { month: 'short' })}
                            </span>
                        </div>
                        <div className="min-w-0 flex-1">
                            <div className="flex items-center gap-1.5 mb-0.5">
                                <h4 className="text-[13px] font-normal text-slate-900 truncate group-hover:text-emerald-600 transition-colors tracking-tight">{event.title}</h4>
                                {event.type === 'plan' ? (
                                    <span className="text-[7px] font-normal bg-emerald-500 text-white px-1 py-0.5 rounded-sm">Plan</span>
                                ) : event.type === 'assignment' ? (
                                    <span className="text-[7px] font-normal bg-indigo-600 text-white px-1 py-0.5 rounded-sm">Assigned</span>
                                ) : (
                                    <span className="text-[7px] font-normal bg-emerald-600 text-white px-1 py-0.5 rounded-sm">Live</span>
                                )}
                            </div>
                            <p className="text-[10px] font-normal text-slate-500 truncate">
                                {event.type === 'plan' ? event.plan_name : event.company} • {formatTime(event.scheduled_at?.Time || event.scheduled_at)}
                            </p>
                        </div>
                        <div className="shrink-0">
                            <div className="px-2 py-1 bg-emerald-50 border border-emerald-100/50 rounded-lg shadow-sm group-hover:bg-emerald-600 group-hover:border-emerald-600 transition-all">
                                <span className="text-[9px] font-normal text-emerald-700 group-hover:text-white whitespace-nowrap transition-colors">
                                    {formatDate(event.scheduled_at?.Time || event.scheduled_at)}
                                </span>
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className="py-6 text-center border-2 border-dashed border-slate-100 rounded-2xl">
                        <Icon name="Calendar" size={24} className="text-slate-200 mx-auto mb-2" />
                        <p className="text-[12px] font-normal text-slate-500">No interviews this week</p>
                    </div>
                )}
            </div>
            
            {/* {events.length > 0 && (
                <button 
                    onClick={() => navigate('/interview-calendar')}
                    className="w-full mt-4 py-3 text-[11px] font-normal text-slate-700 hover:text-emerald-600 transition-all tracking-widest border-t border-slate-50 pt-4 flex items-center justify-center gap-2"
                >
                    Full Schedule <Icon name="ArrowRight" size={12} />
              </button>
            )} */}
        </div>
    );
};

export default UpcomingEvents;
